<template>
  <div>
    <div class="header">
      <router-link
        :to="{ path: `/` }"
        class="back">
          ←
      </router-link>
      {{ serverOrigin || userEmail }}
    </div>
    <div class="page">
      <div class="sidebar">
        <Fetcher />
        <UserSearch />
        <SessionList :serverOrigin="serverOrigin"/>
      </div>
      <router-view/>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Fetcher from '@/components/Fetcher'
import UserSearch from '@/components/UserSearch'
import SessionList from '@/components/SessionList'

export default {
  name: 'Layout',
  props: {
    serverOrigin: String,
    userEmail: String
  },
  data () {
    return {
      searchParams: {
        serverOrigin: this.serverOrigin,
        userEmail: this.userEmail
      }
    }
  },
  created () {
    this.updateEvents()
  },
  components: {
    Fetcher,
    UserSearch,
    SessionList
  },
  methods: {
    updateEvents () {
      if (this.gotFilter) this.loadFiltered(this.searchParams)
    },
    ...mapActions([
      'loadFiltered'
    ])
  },
  watch: {
    '$route' (to, _from) {
      /* Update state. */
      this.searchParams = {
        serverOrigin: to.params.serverOrigin || this.searchParams.serverOrigin,
        userEmail: to.params.userEmail || this.searchParams.userEmail
      }
      this.updateEvents()
    }
  },
  computed: {
    gotFilter () {
      let {userEmail, serverOrigin} = this.searchParams
      return [userEmail, serverOrigin].some(Boolean)
    },
    ...mapGetters([
      'filteredEvents'
    ])
  }
}
</script>

<style>

.back {
  color: #212121;
  text-decoration: none;
  cursor: pointer;

  padding: 10px;
  margin-left: -10px;
}

</style>
